import { ReactNode } from 'react';
import GeneralLayout from '../components/layouts/GeneralLayout';
import EntryAppLayout from '../components/layouts/EntryAppLayout';
// import TestNeilLayout from '../components/layouts/TestNeilLayout';


export function withGeneralLayout(Component: ReactNode) {
  return <GeneralLayout>{Component}</GeneralLayout>;
}

export function withEntryAppLayout(Component: ReactNode) {
  return <EntryAppLayout>{Component}</EntryAppLayout>;
}


{/* SECOND WAY TO USE THIS */}
// export function withTestNeilLayout(Component: ReactNode) {
//   return <TestNeilLayout>{Component}</TestNeilLayout>;
// }
